import { PaletteOptions, SimplePaletteColorOptions } from "@mui/material/styles/createPalette";

import { blueGrey, lightBlue, lightGreen, orange, red } from "@mui/material/colors";

interface PastelPaletteExtensions {
  default: SimplePaletteColorOptions;
  info: SimplePaletteColorOptions;
  warning: SimplePaletteColorOptions;
  error: SimplePaletteColorOptions;
  success: SimplePaletteColorOptions;
}

declare module "@mui/material/styles/createPalette" {
  interface Palette {
    pastel: PastelPaletteExtensions;
  }
  interface PaletteOptions {
    pastel?: PastelPaletteExtensions;
  }
}

export const palette: PaletteOptions = {
  primary: {
    main: "#2e66b2",
  },
  secondary: {
    main: blueGrey[900],
  },
  info: {
    main: lightBlue[500],
  },
  error: {
    main: red[800],
  },
  warning: {
    main: orange[800],
  },
  background: {
    default: "#e5ecf7",
  },
  grey: blueGrey,
  pastel: {
    default: {
      main: blueGrey[200],
    },
    info: {
      main: lightBlue[100],
    },
    warning: {
      main: orange[300],
    },
    error: {
      main: red[200],
    },
    success: {
      main: lightGreen[400],
    },
  },
};
